import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppIcon = ({ phoneNumber = "+923295239629", message = "Hello! I am interested in registering my profile on Select Proposal" }) => {
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  
  const whatsappButtonStyle = {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    backgroundColor: "#25D366",
    borderRadius: "50%",
    width: "60px",
    height: "60px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.3)",
    cursor: "pointer",
    zIndex: 1000,
    transition: "all 0.3s"
  };

  const iconStyle = {
    width: "30px",
    height: "30px"
  };

  return (
    <a 
      href={whatsappUrl} 
      target="_blank" 
      rel="noopener noreferrer"
      style={whatsappButtonStyle}
      title="Chat with us on WhatsApp"
      onMouseOver={(e) => {
        e.currentTarget.style.transform = "scale(1.1)";
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = "scale(1)";
      }}
    >
      <FaWhatsapp className="w-8 h-8 text-white" />
    </a>
  );
};

export default WhatsAppIcon;